import React, { useState } from 'react';

const supportedEvents = [
  'billing.invoice.created',
  'billing.payment.success',
  'ticket.created',
  'ticket.updated',
  'monitoring.incident.created',
  'monitoring.incident.resolved',
  'provisioning.customer.created',
  'provisioning.activation.success',
];

const CreateWebhookModal = ({ open, clients = [], onClose, onSubmit, loading }) => {
  const [targetUrl, setTargetUrl] = useState('');
  const [clientId, setClientId] = useState('');
  const [eventTypes, setEventTypes] = useState(['ticket.created']);

  if (!open) return null;

  const toggleEvent = (eventType) => {
    setEventTypes((prev) => (prev.includes(eventType) ? prev.filter((item) => item !== eventType) : [...prev, eventType]));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!targetUrl.trim() || !clientId || eventTypes.length === 0 || loading) return;
    onSubmit({ targetUrl: targetUrl.trim(), clientId, eventTypes });
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-xl rounded-xl border border-slate-700 bg-slate-950 p-4">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-slate-100">Buat Webhook</h3>
          <button type="button" onClick={onClose} className="text-xs text-slate-400 hover:text-slate-200">Tutup</button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3">
          <label className="block text-xs text-slate-300">
            API Client
            <select value={clientId} onChange={(e) => setClientId(e.target.value)} className="mt-1 w-full rounded border border-slate-700 bg-slate-900 px-2 py-2 text-sm text-slate-100">
              <option value="">Pilih client</option>
              {clients.map((client) => <option key={client.clientId} value={client.clientId}>{client.name} ({client.clientId})</option>)}
            </select>
          </label>
          <label className="block text-xs text-slate-300">
            Target URL
            <input value={targetUrl} onChange={(e) => setTargetUrl(e.target.value)} placeholder="https://partner.example.com/webhook" className="mt-1 w-full rounded border border-slate-700 bg-slate-900 px-2 py-2 text-sm text-slate-100" />
          </label>
          <div>
            <p className="mb-1 text-xs text-slate-300">Event Types</p>
            <div className="grid gap-2 sm:grid-cols-2">
              {supportedEvents.map((eventType) => (
                <label key={eventType} className="flex items-center gap-2 rounded border border-slate-700 bg-slate-900 px-2 py-1.5 text-xs text-slate-200">
                  <input type="checkbox" checked={eventTypes.includes(eventType)} onChange={() => toggleEvent(eventType)} />
                  {eventType}
                </label>
              ))}
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="rounded border border-slate-700 px-3 py-2 text-xs text-slate-300">Batal</button>
            <button type="submit" disabled={loading} className="rounded border border-cyan-400/45 bg-cyan-500/15 px-3 py-2 text-xs font-semibold text-cyan-200 disabled:opacity-50">
              {loading ? 'Menyimpan...' : 'Buat Webhook'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateWebhookModal;
